<template>
    <v-container fluid>
        <v-toolbar flat color="white">
            <v-toolbar-title>Сотрудники</v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-btn v-if="this.user_role == 'ROLE_ADMIN' || this.user_role == 'ROLE_CUSTOMER_ADMIN'" color="info" dark class="mb-2" @click="openDialog">Добавить сотрудника</v-btn>
            <v-dialog v-if="this.user_role == 'ROLE_ADMIN' || this.user_role == 'ROLE_CUSTOMER_ADMIN'" v-model="dialog" max-width="700px">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-alert
                            :value="successAlert"
                            dismissible
                            type="success"
                    >
                        {{successText}}
                    </v-alert>
                    <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation
                    >
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm6 md6 field-block>
                                        <div v-if="editedItem.username && editedItem.username.length >= 76 && editedItem.username.length < 100" class='max-length-block'>Осталось {{100 - editedItem.username.length}} символов</div>
                                        <v-text-field v-model="editedItem.username" :rules="requiredRules" :error-messages="inputErrors.username" maxlength="100" required :disabled="editedIndex == -1 ? false : true">
                                            <template slot="label">
                                                Логин сотрудника <span v-if="editedIndex == -1" class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6 field-block>
                                        <div v-if="editedItem.password && editedItem.password.length >= 76 && editedItem.password.length < 100" class='max-length-block'>Осталось {{100 - editedItem.password.length}} символов</div>

                                        <v-text-field v-model="editedItem.password" :rules="passwordRules" :error-messages="inputErrors.password" label="Пароль" maxlength="100" required>
                                            <template slot="label">
                                                Пароль <span v-if="editedIndex == -1" class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 field-block>
                                        <div v-if="editedItem.fullname && editedItem.fullname.length >= 76 && editedItem.fullname.length < 100" class='max-length-block'>Осталось {{100 - editedItem.fullname.length}} символов</div>

                                        <v-text-field v-model="editedItem.fullname" :rules="requiredRules" :error-messages="inputErrors.fullname" maxlength="100" required>
                                            <template slot="label">
                                                ФИО <span class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 field-block>
                                        <div v-if="editedItem.email && editedItem.email.length >= 76 && editedItem.email.length < 100" class='max-length-block'>Осталось {{100 - editedItem.email.length}} символов</div>

                                        <v-text-field v-model="editedItem.email" :rules="emailRules" :error-messages="inputErrors.email" maxlength="100" required>
                                            <template slot="label">
                                                Адрес элетронной почты <span class='error-file'>*</span>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                                v-if="this.user_role == 'ROLE_ADMIN'"
                                                :items="roles"
                                                item-text="name"
                                                item-value="val"
                                                no-data-text="Нет доступных для выбора"
                                                v-model="editedItem.role"
                                                :rules="requiredRules"
                                                :error-messages="inputErrors.role"
                                                required
                                        >
                                            <template slot="label">
                                                Роль <span class='error-file'>*</span>
                                            </template>
                                        </v-select>
                                        <v-select
                                                v-else-if="this.user_role == 'ROLE_CUSTOMER_ADMIN'"
                                                :items="roles2"
                                                item-text="name"
                                                item-value="val"
                                                no-data-text="Нет доступных для выбора"
                                                v-model="editedItem.role"
                                                :rules="requiredRules"
                                                :error-messages="inputErrors.role"
                                                required
                                        >
                                            <template slot="label">
                                                Роль <span class='error-file'>*</span>
                                            </template>
                                        </v-select>
                                    </v-flex>
                                    <v-flex xs12 v-if="(editedItem.role == 'ROLE_CUSTOMER_ADMIN'  || editedItem.role == 'ROLE_CUSTOMER_WORKER') && this.user_role != 'ROLE_CUSTOMER_ADMIN'">
                                        <v-select
                                                :items="customers"
                                                item-text="name"
                                                item-value="id"
                                                label="Заказчик"
                                                no-data-text="Нет доступных для выбора заказчоков "
                                                v-model="editedItem.customerId"
                                                :error-messages="inputErrors.customerId"
                                                required
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click="close">Отменить</v-btn>
                            <v-btn color="success" flat @click="save">Сохранить</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
            <v-spacer></v-spacer>
            <v-btn color="info" dark class="mb-2" @click="refreshData">
                <i class="material-icons">
                    refresh
                </i>  Обновить
            </v-btn>
            <v-flex xs6 sm3>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        class="table-search"
                        label="Поиск"
                        single-line
                        hide-details
                ></v-text-field>
            </v-flex>
        </v-toolbar>
        <v-alert
                :value="deleteTextAlert"
                type="success"
        >
            {{deleteText}}
        </v-alert>

        <v-data-table
                :headers="user_role == 'ROLE_ADMIN' ? headers : user_role == 'ROLE_CUSTOMER_ADMIN' ? headers2 : headers3"
                :role="user_role"
                :items="users"
                :pagination.sync="pagination"
                :total-items="totalUsers"
                :loading="loading"
                :light=true
                no-data-text=""
                no-results-text=""
                rows-per-page-text="Строк на странице"
                :rows-per-page-items='[ 15, 30, 50, { "text": "все", "value": -1 } ]'
                class="elevation-1"


        >
            <template slot="items" slot-scope="props">

                <td>{{ props.item.username}}</td>
                <td>{{ props.item.fullname }}</td>
                <td>{{ props.item.email}}</td>
                <td>{{ props.item.role2 }}</td>
                <td v-if="user_role == 'ROLE_ADMIN'">{{ props.item.customerName }}</td>
                <td v-if="user_role == 'ROLE_ADMIN'" class="right layout px-0">

                    <v-btn v-if="props.item.role == 'ROLE_CUSTOMER_ADMIN' || props.item.role == 'ROLE_EXPERT'" color="primary" flat icon @click="editItem(props.item)">
                        <v-icon small>fa-pencil</v-icon>
                    </v-btn>
                    <v-btn v-if="props.item.role == 'ROLE_CUSTOMER_ADMIN' || props.item.role == 'ROLE_EXPERT'" color="red" flat icon @click="deleteItem(props.item)">
                        <v-icon small>fa-trash</v-icon>
                    </v-btn>
                </td>
                <td v-else-if="user_role == 'ROLE_CUSTOMER_ADMIN'" class="action-buttons justify-center">

                    <v-btn v-if="props.item.role == 'ROLE_CUSTOMER_WORKER'" color="primary" flat icon @click="editItem(props.item)">
                        <v-icon small>fa-pencil</v-icon>
                    </v-btn>
                    <v-btn v-if="props.item.role == 'ROLE_CUSTOMER_WORKER'" color="red" flat icon @click="deleteItem(props.item)">
                        <v-icon small>fa-trash</v-icon>
                    </v-btn>
                </td>
            </template>
        </v-data-table>

        <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :total-visible="7" :length="pages"></v-pagination>
        </div>
    </v-container>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios'

    export default{
        data: () => ({
            backUrl: null,
            totalUsers: 0,
            loading: true,
            valid: true,
            menu: false,
            modal: false,
            menu2: false,
            dialog: false,
            headers: [
                { text: 'Логин сотрудника',value: 'username'},
                { text: 'ФИО', value: 'fullname' },
                { text: 'Адрес элетронной почты', value: 'email' },
                { text: 'Роль', value: 'role2' },
                { text: 'Заказчик',value: 'customerName', sortable: false},
                { text: 'Действия',align: 'center',class: 'agent-actions', sortable: false }
            ],
            headers2: [
                { text: 'Логин сотрудника',value: 'username'},
                { text: 'ФИО', value: 'fullname' },
                { text: 'Адрес элетронной почты', value: 'email' },
                { text: 'Роль', value: 'role2' },
                { text: 'Действия',align: 'center',class: 'agent-actions', sortable: false }
            ],
            headers3: [
                { text: 'Логин сотрудника',value: 'username'},
                { text: 'ФИО', value: 'fullname' },
                { text: 'Адрес элетронной почты', value: 'email' },
                { text: 'Роль', value: 'role2' },
            ],
            users: [],
            inputErrors:[],
            pagination: {
                sortBy: ''
            },
            editedIndex: -1,
            search: '',

            deleteText:'',
            deleteTextAlert: false,
            successAlert:false,
            successText:'',
            editedItem: {
                id: '',
                uuid: '',
                username: '',
                fullname: '',
                email: '',
                status: '',
                customerId: '',
                password: '',
                role: ''
            },
            defaultItem: {
                username: '',
                fullname: '',
                password: '',
                status: '',
                email: '',
                customerId: '',
                role: '',
            },
            customers: [],
            token:'',
            user_role:'',
            user_customerId:'',
            roles: [
                {
                    name: "Администратор",
                    val: "ROLE_ADMIN"
                },
                {
                    name: "Эксперт",
                    val: "ROLE_EXPERT"
                },
                {
                    name: "Администратор заказчика",
                    val: "ROLE_CUSTOMER_ADMIN"
                }
            ],
            roles2: [
                {
                    name: "Администратор",
                    val: "ROLE_CUSTOMER_ADMIN"
                },
                {
                    name: "Сотрудник",
                    val: "ROLE_CUSTOMER_WORKER"
                }
            ],
            requiredRules: [
                v => !!v || 'Значение должно быть заполнено',
            ],
            passwordRules: [
                v => !!v || 'Значение должно быть заполнено',
            ],
            emailRules: [
                (v) => !!v || 'Значение должно быть заполнено',
                 v => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(v) || 'Адрес элетронной почты должен быть действительным'
                 },
            ],



        }),

        created () {
            this.token = localStorage.getItem('token');
            this.user_role = localStorage.getItem('role');
            this.backUrl = localStorage.getItem('url');
            this.user_customerId = localStorage.getItem('user_customerId');

            if(this.user_role == 'ROLE_ADMIN') {
                this.getCustomers();
            }
        },

        watch: {

            pagination: {
                handler () {
                    this.getUsers();
                },
                deep: true
            },

            dialog (val) {
                val || this.close()
            },
            search() {
                this.getUsers('search');
            },
        },

        computed: {

            formTitle () {
                return this.editedIndex === -1 ? 'Новый сотрудник' : 'Редактировать сотрудника'
            },

            pages () {
                if (this.pagination.rowsPerPage == null ||
                    this.totalUsers == null
                ) return 0

                return Math.ceil(this.totalUsers / this.pagination.rowsPerPage)
            },
        },

        methods: {

            getUsers(index) {
                this.deleteText = ''
                this.deleteTextAlert = false
                let startIndex = (this.pagination.page - 1) * this.pagination.rowsPerPage
                let params = {}
                this.loading = true;
                // get by search keyword
                if (this.search && !this.pagination.sortBy) {

                    if (index === 'search') {
                        params = {
                            start_index: 0,
                            count: this.pagination.rowsPerPage,
                            like_username:  this.search,
                        }
                    }else {
                        params = {
                            start_index: startIndex,
                            count: this.pagination.rowsPerPage,
                            like_username:  this.search,
                        }
                    }
                }
                else if (this.pagination.sortBy && !this.search) {

                    const direction = this.pagination.descending ? 'DESC' : 'ASC';

                    let sortBy = ''

                    if(this.pagination.sortBy == 'username'){
                        sortBy = 'sort_username'
                    }else if(this.pagination.sortBy == 'fullname'){
                        sortBy = 'sort_fullname'
                    }else if(this.pagination.sortBy == 'email'){
                        sortBy = 'sort_email'
                    }else if(this.pagination.sortBy == 'role2'){
                        sortBy = 'sort_role'
                    }

                    params = {
                        start_index: startIndex,
                        count: this.pagination.rowsPerPage,
                        [sortBy]: direction,
                    }

                }
                else if(!this.search && !this.pagination.sortBy) {

                    params = {
                        start_index: startIndex,
                        count: this.pagination.rowsPerPage
                    }
                }
                else if(this.search && this.pagination.sortBy) {

                    const direction = this.pagination.descending ? 'DESC' : 'ASC';

                    let sortBy = ''

                    if(this.pagination.sortBy == 'username'){
                        sortBy = 'sort_username'
                    }else if(this.pagination.sortBy == 'fullname'){
                        sortBy = 'sort_fullname'
                    }else if(this.pagination.sortBy == 'email'){
                        sortBy = 'sort_email'
                    }else if(this.pagination.sortBy == 'role2'){
                        sortBy = 'sort_role'
                    }

                    params = {
                        start_index: startIndex,
                        count: this.pagination.rowsPerPage,
                        like_username:  this.search,
                        [sortBy]: direction
                    }
                }

                axios({
                    method: 'get',
                    url: this.backUrl + '/api/users',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                    params: params
                  })
                    .then(response => {
                        if(response.data) {
                            let usersArr = response.data.data;

                            for (let i = 0; i < usersArr.length; i++) {
                                Vue.set(usersArr[i], 'role2', this.showRole(usersArr[i].role))
                                if (usersArr[i].customerId != null) {
                                    axios({
                                        method: 'get',
                                        url: this.backUrl + '/api/customers/' + usersArr[i].customerId,
                                        withCredentials: true,
                                        headers: {
                                            'Authorization': 'Basic ' + this.token
                                        },
                                    }).then(response => {
                                        Vue.set(usersArr[i], 'customerName', response.data.name)

                                    })
                                }
                            }

                            setTimeout(() => {
                                Vue.nextTick(() => this.users = usersArr);
                                    this.loading = false
                            }, 300)
                            this.totalUsers = Number(response.data.metadata.total_count);
                        }else{
                             setTimeout(() => {
                                    this.users = []
                                    this.totalUsers = 0
                                    this.loading = false
                             }, 100)
                        }
                    })
                    .catch(() => this.loading = false)
            },

            refreshData(){
                this.getUsers();
                if(this.user_role == 'ROLE_ADMIN') {
                    this.getCustomers();
                }
            },

            showRole(role){
                if(this.user_role == 'ROLE_ADMIN' || this.user_role == 'ROLE_EXPERT') {
                    if (role == "ROLE_ADMIN") {
                        return "Администратор"
                    } else if (role == "ROLE_EXPERT") {
                        return "Эксперт"
                    } else if (role == "ROLE_CUSTOMER_ADMIN") {
                        return "Администратор заказчика"
                    } else {
                        return "Сотрудник заказчика"
                    }
                }else{
                 if (role == "ROLE_CUSTOMER_ADMIN") {
                        return "Администратор"
                    } else {
                        return "Сотрудник"
                    }
                }
            },

            openDialog(){
                this.inputErrors = ''
                this.passwordRules = [
                    v => !!v || 'Значение должно быть заполнено',
                ],
                this.$refs.form.resetValidation()
                this.dialog = true
            },

            editItem (item) {
                this.inputErrors = ''
                this.passwordRules = []
                this.editedIndex = this.users.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (item) {
                this.editedItem = Object.assign({}, item)
                const index = this.users.indexOf(item)


                if(confirm('Вы уверены, что хотите удалить этого сотрудника ?')) {
                    axios({
                        method: 'delete',
                        url: this.backUrl + '/api/users',
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {
                            id: this.editedItem.id,
                            uuid: this.editedItem.uuid,
                        },
                    }).then(() => {
                        this.users.splice(index, 1)
                        this.deleteText = 'Успешно удален'
                        this.deleteTextAlert = true
                        setTimeout(() => {
                            this.deleteTextAlert = false
                        }, 3000)

                    }).catch(error => {
                        if(error.response.data.code == 401){
                            this.$router.push('/login');
                        }
                    });
                }

            },

            close () {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                    this.inputErrors = ''

                    this.successAlert = false
                    this.successText = ''
                    this.deleteText = ''
                    this.deleteTextAlert = false
                }, 300)
            },

            save () {
                this.inputErrors = ''
                if (this.$refs.form.validate()) {
                if(this.user_role == 'ROLE_CUSTOMER_ADMIN'){
                    this.editedItem.customerId = this.user_customerId
                }
                if (this.editedIndex == -1) {
                axios({
                    method: 'post',
                    url: this.backUrl + '/api/users',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                    data: {
                        fullname: this.editedItem.fullname,
                        status: 'ACTIVE',
                        customerId: this.editedItem.customerId,
                        email: this.editedItem.email,
                        role: this.editedItem.role,
                        username: this.editedItem.username,
                        password: this.editedItem.password,
                    },
                }).then(() => {
                    this.getUsers();
                    this.inputErrors = ''

                    if (this.editedIndex > -1) {
                        Object.assign(this.users[this.editedIndex], this.editedItem)
                    } else {
                        this.users.push(this.editedItem)
                    }
                    // this.close()
                    this.successText = 'Успешно добавлен'
                    this.successAlert = true
                    setTimeout(() => {
                        this.close()
                    }, 1500)
                }).catch(error => {

                    if(error.response.data.code == 401){
                        this.$router.push('/login');
                    }
                    let errors = error.response.data.rows;
                    this.inputErrors = errors

                });

            } else {
                    axios({
                        method: 'put',
                        url: this.backUrl + '/api/users',
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {
                            id: this.editedItem.id,
                            uuid: this.editedItem.uuid,
                            customerId: this.editedItem.customerId,
                            fullname: this.editedItem.fullname,
                            email: this.editedItem.email,
                            role: this.editedItem.role,
                            username: this.editedItem.username,
                            password: this.editedItem.password,
                        },
                    }).then(response => {
                        this.getUsers();
                        let res = JSON.parse(response.data.objectJson)

                        if(res.id == localStorage.getItem('user_id')) {
                            let user_customerId = res.customerId;
                            let user_uuid = res.UUID;

                            localStorage.setItem('user_customerId', user_customerId);
                            localStorage.setItem('user_uuid', user_uuid);
                        }
                        this.inputErrors = ''
                        if (this.editedIndex > -1) {
                            Object.assign(this.users[this.editedIndex], this.editedItem)
                        } else {
                            this.users.push(this.editedItem)
                        }
                        // this.close()
                        this.successText = 'Успешно изменен'
                        this.successAlert = true
                        setTimeout(() => {
                            this.close()
                        }, 1500)
                    }).catch(error => {

                        if(error.response.data.code == 401){
                            this.$router.push('/login');
                        }
                        let errors = error.response.data.rows;
                        this.inputErrors = errors

                    });
                  }
                  }
            },

            getCustomers() {
                axios({
                      method: 'get',
                      url: this.backUrl + '/api/customers',
                      withCredentials: true,
                      headers:{
                          'Authorization': 'Basic ' + this.token
                },
                }).then(response => {
                      this.customers = response.data.data;
                })
            }
        }
    }
</script>
<style>

</style>